import type { ContestChecklistValue } from "@/types/contest-submission";

/**
 * 1차 심사 형식 요건 정의 — novela-server
 * apps/api/src/contest/contest-checklist.constants.ts 와 key 를 반드시 일치시킬 것.
 * 서버는 key 멤버십을 검증하지 않으므로 항목 변경 시 legacy 값은 그대로 남는다.
 */
export interface ContestChecklistItemDef {
  key: string;
  label: string;
  /** 목록 테이블 뱃지용 축약 라벨 */
  shortLabel: string;
  order: number;
  /** 자동 참고 정보 표시 (예: charCount) */
  autoHint?: "charCount";
}

export const CONTEST_CHECKLIST_ITEMS: ContestChecklistItemDef[] = [
  { key: "char_count", order: 1, label: "분량 기준 충족", shortLabel: "분량", autoHint: "charCount" },
  { key: "file_ok", order: 2, label: "파일 정상 (손상·암호화 없음)", shortLabel: "파일" },
  { key: "personal_info", order: 3, label: "개인정보 기재", shortLabel: "개인정보" },
  { key: "required_info", order: 4, label: "필수 응모정보 기재", shortLabel: "응모정보" },
  { key: "required_fields", order: 5, label: "필수항목(시놉시스·줄거리 등) 작성", shortLabel: "필수항목" },
  { key: "genre_fit", order: 6, label: "장르 적합 (오컬트)", shortLabel: "장르" },
  { key: "pledge_ok", order: 7, label: "표절·중복투고 서약", shortLabel: "서약" },
  { key: "no_prior_release", order: 8, label: "기존 공개·수상 이력 없음", shortLabel: "공개이력" },
  { key: "entry_limit", order: 9, label: "응모 편수 준수", shortLabel: "편수" },
];

const DEF_BY_KEY = new Map(CONTEST_CHECKLIST_ITEMS.map((item) => [item.key, item]));

/** unknown key(항목 변경 후 legacy 값)는 key 그대로 노출 — forward-compat. */
export function checklistLabel(key: string): string {
  return DEF_BY_KEY.get(key)?.label ?? key;
}

export function checklistShortLabel(key: string): string {
  return DEF_BY_KEY.get(key)?.shortLabel ?? key;
}

/**
 * 체크리스트 → 판정 자동 제안.
 * X 가 하나라도 있으면 부적격(FAIL), 정의된 8개 항목이 전부 O 면 적격(PASS),
 * 그 외(미정 남음/비어있음)는 제안 없음. 확정은 항상 사람이 한다.
 */
export function deriveSuggestion(
  entries: Array<{ key: string; value: ContestChecklistValue }>,
): "PASS" | "FAIL" | null {
  if (entries.some((entry) => entry.value === "X")) return "FAIL";
  const valueByKey = new Map(entries.map((entry) => [entry.key, entry.value]));
  const allKnownO = CONTEST_CHECKLIST_ITEMS.every(
    (item) => valueByKey.get(item.key) === "O",
  );
  return allKnownO ? "PASS" : null;
}
